import React from "react";
import { MDBIcon, MDBTooltip } from "mdb-react-ui-kit";

const MessageFilters = ({ viewType, onViewTypeChange, onAddMessage }) => {
  return (
    <div className="d-flex align-items-center" style={{ marginRight: '2rem' }}>
      <div style={{ minWidth: 'max-content', cursor: 'pointer', marginRight: '18px' }} onClick={() => onViewTypeChange('card')}>
        <MDBTooltip tag='span' wrapperProps={{ color: 'secondary' }} title="Card View">
          <MDBIcon fas icon="grip" style={{ color: viewType === 'card' ? '#1266f1' : '#000' }} />
        </MDBTooltip>
      </div>
      <div style={{ minWidth: 'max-content', cursor: 'pointer', marginRight: '18px' }} onClick={() => onViewTypeChange('table')}>
        <MDBTooltip tag='span' wrapperProps={{ color: 'secondary' }} title="Table View">
          <MDBIcon fas icon="list" style={{ color: viewType === 'table' ? '#1266f1' : '#000' }} />
        </MDBTooltip>
      </div>
      <div style={{ minWidth: 'max-content', cursor: 'pointer' }} onClick={onAddMessage}>
        <MDBTooltip tag='span' wrapperProps={{ color: 'secondary' }} title="Add Message">
          <MDBIcon fas icon="plus" />
        </MDBTooltip>
      </div>
    </div>
  );
};

export default MessageFilters; 